import { useTheme } from '@mui/material';
const useLiveFeedStyles = () => {
    const theme = useTheme();
    return {
        containerStyles: {
            maxHeight: 'calc(100dvh - 130px)',
            backgroundColor: theme.palette.background.default,
            overflow: 'auto'
        },
        headerStyles: {
            display: 'flex',
            alignItems: 'center',
            mb: 2
        },
        breadcrumbStyles: {
            color: theme.palette.text.secondary
        },
        videoContainerStyles: {
            position: 'relative'
        },
        videoBoxStyles: {
            width: '100%',
            height: {
                xs: 'calc(25vh - 40px)', // Mobile: 25% of viewport height
                sm: 'calc(30vh - 40px)', // Small: 30% of viewport height
                md: 'calc(35vh - 40px)', // Medium: 35% of viewport height
                lg: 'calc(40vh - 40px)', // Large: 40% of viewport height
                xl: 'calc(45vh - 40px)' // Extra Large: 45% of viewport height
            },
            borderRadius: 2,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        videoImageStyles: {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            backgroundColor: '#000'
        },
        controlsOverlayStyles: {
            position: 'absolute',
            top: 16,
            right: 16,
            display: 'flex',
            gap: 1
        },
        controlButtonStyles: {
            color: theme.palette.primary.main,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)'
            }
        },
        timestampStyles: {
            position: 'absolute',
            bottom: 16,
            left: 16,
            color: 'white',
            fontWeight: 600,
            fontSize: '16px'
        },
        zonesCardStyles: {
            p: 0,
            height: 'calc(100vh - 200px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        zonesHeaderStyles: {
            p: 2
        },
        addButtonStyles: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        },
        cameraLabelStyles: {
            mx: 2,
            color: 'textPrimary'
        },
        zoneListStyles: {
            flex: 1,
            overflow: 'auto'
        },
        accordionStyles: {
            boxShadow: 'none',
            '&:before': { display: 'none' },
            '&.Mui-expanded': {
                margin: 0
            },
            borderBottom: `1px solid ${theme.palette.divider}`,
            '&:last-child': {
                borderBottom: 'none'
            }
        },
        accordionSummaryStyles: {
            minHeight: 56,
            px: 2,
            alignItems: 'center',
            '&.Mui-expanded': {
                minHeight: 56
            },
            '& .MuiAccordionSummary-content': {
                alignItems: 'center',
                margin: 0,
                '&.Mui-expanded': {
                    margin: 0
                }
            }
        },
        accordionContentStyles: {
            width: '100%',
            alignItems: 'center'
        },
        zoneInfoStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 2
        },
        zoneRightSideStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        colorBoxStyles: (color) => ({
            width: 20,
            height: 20,
            backgroundColor: color,
            borderRadius: '4px'
        }),
        expandIconStyles: (isExpanded) => ({
            fontSize: 20,
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
        }),
        accordionDetailsStyles: {
            px: 2,
            py: 1,
            pt: 0
        },
        detailRowStyles: {
            mt: 1.5,
            gap: 2
        },
        detailLabelStyles: {
            color: theme.palette.text.secondary,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        },
        textFieldStyles: {
            minWidth: 150
        },
        formControlStyles: {
            minWidth: 190
        },
        selectStyles: {
            fontSize: '0.875rem'
        },
        saveButtonStyles: {
            mt: 2,
            alignSelf: 'flex-end'
        }
    };
};
export default useLiveFeedStyles;
